import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { useAuthStore } from '../../auth/auth.store';

export default function GlobalToast() {
  const apiError = useAuthStore((state) => state.apiError);
  const clearApiError = useAuthStore((state) => state.clearApiError);

  const isOpen = Boolean(apiError);

  return (
    <Transition show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        onClose={clearApiError}
      >
        {/* Backdrop */}
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/50 backdrop-blur-sm" />
        </Transition.Child>

        {/* Modal container */}
        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-200"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-150"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className="
                  w-full max-w-md
                  transform overflow-hidden
                  rounded-2xl
                  border border-[var(--color-error)]/20
                  bg-white
                  p-6
                  shadow-2xl
                  transition-all
                  dark:bg-gray-900
                "
              >
                {/* Error icon */}
                <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-[var(--color-error)]/10">
                  <svg
                    className="h-6 w-6 text-[var(--color-error)]"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 9v4m0 4h.01M10.29 3.86l-7.5 13A2 2 0 004.52 20h14.96a2 2 0 001.73-3.14l-7.5-13a2 2 0 00-3.42 0z"
                    />
                  </svg>
                </div>

                {/* Title */}
                <Dialog.Title
                  as="h3"
                  className="mt-4 text-center text-lg font-semibold text-gray-900 dark:text-white"
                >
                  Error
                </Dialog.Title>

                {/* Message */}
                <div className="mt-3 text-center">
                  <p className="text-sm leading-6 text-gray-600 dark:text-gray-300">
                    {apiError}
                  </p>
                </div>

                {/* Close button */}
                <div className="mt-6 flex justify-center">
                  <button
                    type="button"
                    onClick={clearApiError}
                    className="
                      rounded-lg
                      bg-[var(--color-error)]
                      px-5 py-2.5
                      text-sm font-semibold
                      text-white
                      shadow-sm
                      transition
                      hover:opacity-90
                      focus:outline-none
                      focus:ring-2
                      focus:ring-[var(--color-error)]/50
                      focus:ring-offset-2
                    "
                  >
                    Close
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
